import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import './Alert.css';

const Alert = ({ alerts }) => {
  console.log(" lol")
  if (alerts != null && alerts.length > 0) {
    console.log("YES")
    return alerts.map((alert) => (
      <div key={alert.id} className={`${alert.type}-alert`}>
        {alert.message}
      </div>
    ));
  } else {
    return <></>;
  }
};

Alert.propTypes = {
  alerts: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  alerts: state.alert,
});

export default connect(mapStateToProps)(Alert);
